import { createApp } from 'vue';
import App from '@/App';
import store from '@/store/store';
import router from '@/router';
import globals from '@/pugins/globals';
import VueTheMask from 'vue-the-mask';
import VueApexCharts from "vue3-apexcharts";

const app = createApp(App);

app.use(VueTheMask);
app.use(VueApexCharts);
app.component('apexchart-gdb', VueApexCharts);

// wire-frame
import WireFrame from '@/components/WireFrame';
app.component('wire-frame-gdb', WireFrame);

// User Filiais Context
import UserFiliaisContext from '@/components/layouts/partials/UserFiliaisContext';
app.component('user-filiais-context', UserFiliaisContext);

// clock
import ClockGDB from '@/components/layouts/partials/Clock';
app.component('clock-gdb', ClockGDB);

// footer
import NavDrawer from '@/components/layouts/partials/FooterGdb';
app.component('footer-gdb', NavDrawer);

// drawer
import Drawer from '@/components/layouts/partials/Drawer';
app.component('drawer-gdb', Drawer);

// navbar
import Navbar from '@/components/layouts/partials/Navbar';
app.component('navbar-gdb', Navbar);

// chart
import Chart from '@/components/dashboard/Chart';
app.component('chart-gdb', Chart);

// confirm
import Confirm from '@/components/layouts/partials/Confirm.vue';
app.component('confirm-gdb', Confirm);

// cardItem
import CardItem from '@/components/layouts/partials/CardItem';
app.component('card-item', CardItem);

// modal
import Modal from '@/components/layouts/partials/Modal';
app.component('modal-gdb', Modal);

// ícone de ajuda
import HelpInfo from '@/components/layouts/partials/HelpInfo';
app.component('helper-gdb', HelpInfo);

// websocket
import WebSocket from '@/components/layouts/partials/WebSocket';
app.component('ws-gdb', WebSocket);

// loading
import Loading from '@/components/layouts/partials/Loading';
app.component('loading-gdb', Loading);

import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import '@/assets/quilleditor.css';

const quillOptions = {
  debug: 'info',
  modules: {
    toolbar: 'full'
  },
  placeholder: 'Conteúdo aqui...',
  readOnly: false,
  theme: 'snow',
}
// set default globalOptions prop
QuillEditor.props.globalOptions.default = () => quillOptions
app.component('quill-editor', QuillEditor)


// App.css
import '@/assets/app.css'
import '@/assets/toast.css'


// Primevue
// import 'primevue/resources/themes/aura-light-purple/theme.css'
import 'primeicons/primeicons.css'
// import '@/assets/tailwind.css' //replica de tailwind
import PrimeVue from 'primevue/config';
import primevueOptions from '@/pugins/primevueOptions'
import Button from "primevue/button"
app.component('p-btn', Button)

import ToastService from 'primevue/toastservice';
import Tooltip from 'primevue/tooltip';
import Toast from 'primevue/toast';
app.component('toast-gdb', Toast)
app.directive('tooltip', Tooltip);

// Vuetify
import 'vuetify/styles'
// import { createVuetify } from 'vuetify';
// import * as components from 'vuetify/components'
// import * as directives from 'vuetify/directives'
import vuetifyOptions from '@/pugins/vuetify';
    
//Calendar Vue-Cal
import VueCal from 'vue-cal'
import 'vue-cal/dist/vuecal.css'
app.component('vue-cal',VueCal) /** Biblioteca de Calendário */


app.use(ToastService) /** Service de notificações toast */
app.use(router) /** Router */
app.use(vuetifyOptions) /** Biblioteca de Frontend UI */
app.use(PrimeVue, primevueOptions) /** Biblioteca de Frontend UI */
app.use(store) /** Biblioteca para gerenciamento de estados */
app.use(globals) /** Variáveis globais */

app.mount('#app')
